// The MOODS iOS app (apps/ios, Capacitor) and the web build it bundles (docs/DECISIONS.md › iOS uygulaması). Like the
// desktop shell it serves the production web build on `app://moods`. Before the page runs the shell injects
// `window.moodsNative`; native calls go to its `MoodsNative` plugin (apps/ios/ios/App/App/MoodsNativePlugin.swift)
// through Capacitor's injected bridge (`window.Capacitor`), so the web app ships no Capacitor package. The web app only
// talks to it through apps/web/src/lib/ios-bridge.ts and lib/ios.ts. Types only (plus constants).

/** What the shell hands to the web app before it runs (a WKUserScript at document start). */
export interface MoodsNativeShell {
  platform: 'ios';
  /** CFBundleShortVersionString · CFBundleVersion */
  version: string;
  build: string;
  /** endpoints of the build configuration (Debug: the local stack, Release: moods.gg — apps/ios/ios/App/*.xcconfig) */
  config: { apiUrl: string; gatewayUrl: string; siteUrl: string };
}

/** jsName of the app's own Capacitor plugin. */
export const NATIVE_PLUGIN = 'MoodsNative';

/** Keychain items of the plugin — the two tokens the desktop keeps with safeStorage. */
export type NativeSecret = 'refreshToken' | 'deviceToken';

/** Status bar text colour: `light` on dark themes, `dark` on the light theme. */
export type NativeStatusBarStyle = 'light' | 'dark';

/**
 * Plugin events: `deepLink` = a moods:// link or an https://app.moods.gg universal link opened the app; `pushOpened` =
 * a tapped notification, `url` being its in-app path. Both are kept until the web app listens (cold starts).
 */
export interface NativeDeepLinkEvent {
  url: string;
}

/** `pushStatus`: notification permission of the app (`prompt` = never asked). */
export type NativePushStatus = 'granted' | 'denied' | 'prompt';

/** `pushRegister` (asks when never asked, then fetches the APNs device token; sandbox = a debug build). */
export type NativePushRegistration = { status: 'granted'; token: string; sandbox: boolean } | { status: 'denied' };

/** The two calls of Capacitor's injected JS bridge (native-bridge.js) the web app uses. */
export interface CapacitorBridgeGlobal {
  nativePromise<T = unknown>(plugin: string, method: string, options?: object): Promise<T>;
  addListener(plugin: string, event: string, callback: (data: unknown) => void): { remove: () => Promise<void> };
}
